
import { postFsCreate } from '../api/postCreateFs';

const setPostCreateFs = (params, setFs) => {
    return async (dispatch, getState) => {
        try {
            setFs(false)
            const newParams = {
                quantity: params.fsCount,
                uuid: params.game.uuid,
                id: params.id
            }

            await postFsCreate(newParams);
            alert(`${params.fsCount} FS успешно выданы. Игра: ${params.game.name}`)
        } catch(error) {
            setFs(false);
            if (error?.response?.message === 'You already have the same free spin campaign for this game') {
                alert('Ошибка! Пользователь еще не отыграл FS в этой игре')
            } else {
                alert('Неизвестная ошибка')
            }
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateFs
}